module.exports = __webpack_public_path__ + "static/media/6COPUOS4.e116567a.jpg";